<template>
    <div class="mb-4 rounded-xl border border-cyan-100 bg-cyan-50/70 px-4 py-3">
        <p class="text-sm font-bold leading-6 text-cyan-800">{{ text }}</p>
    </div>
</template>

<script>
// Enunciado que abre um questionário — o comando que vale para todos os itens
// listados abaixo dele (ex.: FAAM, ALR-RSI).
export default {
    props: {
        text: String
    }
}
</script>
